<div
  [class.is-hidden]="progressState === true"
  [class.is-dense]="denseButton"
  [class.has-errors]="errors$ | async"
  class="__main-button">
  <ng-content></ng-content>
</div>

<div
  *ngIf="(errors$ | async) as error"
  class="__errors">

  <div
    class="__errors_content"
    [class.is-open]="error">

    <ng-container *ngIf="error">
      <p class="__errors_message">
        <span [innerHTML]="error.data.message"></span>
        <a
          *ngIf="error.data?.meta?.length"
          (click)="!!toggleAdditionalErrorInfo()"
          href=""
          class="__errors_more">

          <span *ngIf="!showAdditionalErrorInfo">
            {{ errorShowDetailsLabel }}?
          </span>

          <span *ngIf="showAdditionalErrorInfo">
            {{ errorHideDetailsLabel }}?
          </span>

        </a>
      </p>

      <div
        *ngIf="error.data?.meta?.length && showAdditionalErrorInfo"
        class="__errors_details-wrap">
        <ul class="__errors_details">
          <li *ngFor="let meta of error.data.meta">
            <strong *ngIf="meta.parameter">{{ meta.parameter }}: </strong>
            {{ meta.message }}
          </li>
        </ul>
      </div>
    </ng-container>

    <div class="__errors_buttons">

      <button
        mat-stroked-button
        *ngIf="errorCloseLabel"
        (click)="!!onResetError$.next()"
        class="__errors_button  __errors_button--close"
        tabindex="-1"
        type="button">
        {{ errorCloseLabel }}
      </button>

      <button
        mat-button
        *ngIf="errorRetryLabel"
        (click)="!!retry.emit()"
        class="__errors_button  __errors_button--retry"
        tabindex="-2"
        type="button">
        <mat-icon>loop</mat-icon> {{ errorRetryLabel }}
      </button>

    </div>

  </div>
</div>

<div *ngIf="progressState && !hideProgressSpinner" class="__progress">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
